import React,
{
    useEffect,
    useState
}
    from "react";

import {
    Drawer,
    Row,
    Col,
    Typography,
    Divider
}
    from "antd";

import { useDispatch, useSelector } from 'react-redux';

import ConversationTimeline
    from "./ConversationTimeline";

import ConversationComposer
    from "./ConversationComposer";

import DealSummaryCard
    from "./DealSummaryCard";

import AgreementFooter
    from "./AgreementFooter";

import ConversationStatusBadge
    from "./ConversationStatusBadge";

import {
    getConversationMessage,
    sendConversationMessage
}
    from "../../servics/marketplace/marketplaceApi";


export default function
    BuyerMarketplaceConversationDrawer({

                                      open,

                                      onClose,

                                      inquiryId,
                                      product
                                  }) {

    const dispatch = useDispatch();

    const countryCode = useSelector(
            state => state.country.country.value
        );

    const [conversation, setConversation] =
        useState(null);

    const [loading, setLoading] =
        useState(false);


    const [
        messageText,

        setMessageText

    ] = useState("");


    useEffect(() => {

        if (!open || !inquiryId) {
            return;
        }

        loadConversation();

        // dispatch(
        //     fetchConversation({
        //         inquiryId,
        //         countryCode
        //     })
        // );

    }, [open, inquiryId]);

    const loadConversation = async () => {

        setLoading(true);

        try {

            const data =
                await getConversationMessage(
                    inquiryId,
                    countryCode
                );

            console.log("The getConversationMessage from Drawer", data)

            setConversation(data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);
        }
    };

    const handleSend = async () => {

        if (!messageText.trim()) {
            return;
        }

        await sendConversationMessage(

            inquiryId,

            {
                message: messageText
            },

            countryCode
        );

        setMessageText("");

        await loadConversation();
    };

    const handleAgreement =
        () => {

            console.log(
                "CREATE ORDER"
            );
        };

    return (

        <Drawer

            width={1000}

            open={open}

            onClose={onClose}

            title={

                <Row
                    justify="space-between"
                >

                    <Typography.Title
                        level={4}
                        style={{
                            margin:0
                        }}
                    >
                        🌽 Conversation
                    </Typography.Title>

                    <ConversationStatusBadge
                        status={
                            conversation?.status
                        }
                    />

                </Row>
            }
        >

            <Row
                gutter={24}
            >

                <Col span={8}>

                    {
                        conversation && (

                            <DealSummaryCard
                                conversation={conversation}
                                product={product}
                            />

                        )
                    }

                </Col>

                <Col span={16}>
                    {
                        conversation && (
                        <ConversationTimeline
                            messages={conversation}
                        />
                        )
                    }
                    <Divider />

                    <ConversationComposer

                        value={
                            messageText
                        }

                        onChange={
                            e =>
                                setMessageText(
                                    e.target.value
                                )
                        }

                        onSend={
                            handleSend
                        }
                    />

                    <div
                        style={{
                            marginTop: 20
                        }}
                    >

                        <AgreementFooter

                            status={
                                conversation?.status
                            }

                            onAgreement={
                                handleAgreement
                            }
                        />

                    </div>

                </Col>

            </Row>

        </Drawer>
    );
}